// Copyright (c) 2020 Verimatrix, Inc.  All Rights Reserved.
import {errorToast} from './toastMessages'

export function unexpectedApiError () {
  return (dispatch) => {
    dispatch(errorToast('There was an unexpected error, please try again later.'))
  }
}
